import { api } from './api'
import type { AppSettings } from '@riverpark/types'

export async function getAppSettings(): Promise<{ data: AppSettings }> {
  return api.get<{ data: AppSettings }>('/settings')
}

export async function updateAppSettings(
  patch: Partial<AppSettings>,
): Promise<{ data: AppSettings }> {
  return api.patch<{ data: AppSettings }>('/settings', patch)
}
